// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB0s8E9A7lFyWJDYlSMoXcAFSeKDUwDu-Q",
  authDomain: "rancho-10e71.firebaseapp.com",
  databaseURL: "https://rancho-10e71.firebaseio.com",
  projectId: "rancho-10e71",
  storageBucket: "rancho-10e71.appspot.com",
  messagingSenderId: "419232539230",
  appId: "1:419232539230:web:400db22f32f3ba5daa8acf",
  measurementId: "G-NQBMGXZ3EL"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
